export const homepageFaqs = [
  {
    question: "How do you support ongoing operations?",
    answer:
      "As a trusted facility management company, we ensure smooth day-to-day operations through maintenance, inspections, repairs, and system optimization. It helps extend asset life, reduce downtime, and maintain safety and performance standards across industrial and commercial facilities.",
  },
  {
    question: "What technical advantages does design build construction offer in complex facilities?",
    answer:
      "Design build construction enables early collaboration between engineers and builders, allowing real-time design adjustments. This reduces rework, improves constructability, optimizes material usage, and enhances overall project efficiency, especially in technically demanding industrial environments.",
  },
  {
    question: "What role do you play in code compliance?",
    answer:
      "As a professional commercial general contractor, we ensure all building activities meet local codes, safety standards, and regulatory requirements. It manages permits, inspections, and documentation, reducing compliance risks while maintaining structural integrity and operational safety throughout the project lifecycle.",
  },
  {
    question: "What technologies are typically deployed by you?",
    answer:
      "As a reliable warehouse automation company, we deploy technologies such as ASRS, conveyors, robotics, sortation systems, and control software. These systems work together to enhance throughput, improve accuracy, and streamline material handling processes in high-volume operations.",
  },
  {
    question: "How does warehouse automation improve picking accuracy and speed?",
    answer:
      "Warehouse automation uses barcode scanning, robotics, and guided systems to reduce manual errors. It accelerates picking processes, ensures precise order fulfillment, and enhances productivity, especially in environments with high SKU counts and complex inventory systems.",
  },
  {
    question: "Can you help with end-to-end solutions?",
    answer:
      "Yes, MTLI USA specializes in end-to-end solutions, covering everything from initial planning and engineering to construction, system integration, and ongoing support. Our full design build construction approach ensures a streamlined process, single-point accountability, and efficient project delivery across every phase.",
  },
  {
    question: "What is the difference between a facility contractor and an industrial construction partner?",
    answer:
      "An industrial construction partner typically works with the broader operational requirements of a facility, including building infrastructure, equipment installation, material handling, and related systems. This broader perspective can be important when construction directly affects how an industrial operation functions.",
  },
  {
    question: "Can MTLI support an existing facility instead of a new construction project?",
    answer:
      "Yes. MTLI supports existing facilities through renovations, expansions, modernization, automation upgrades, installations, relocations, maintenance, and other infrastructure requirements. The appropriate scope depends on the facility's existing conditions and operational needs.",
  },
  {
    question: "How early should an industrial facility partner be involved?",
    answer:
      "Early involvement allows facility requirements, workflow, infrastructure, equipment, and construction considerations to be evaluated together. This can help identify project constraints and coordination requirements before they become more difficult to address during construction or installation.",
  },
  {
    question: "Does MTLI work with multiple industries or only warehouse operations?",
    answer:
      "MTLI supports a range of industries, including warehousing and distribution, 3PL and logistics, e-commerce fulfillment, manufacturing, food and beverage, cold storage, pharmaceutical, automotive, retail, aerospace and defense, cannabis, government and public sector, and technology.",
  },
];
